import { ChevronLeft, ChevronRight, MoveRight } from "lucide-react";
import { useState, useEffect } from "react";
import { images } from "../../assets/assets";
import { Link } from "react-router-dom";
import { getImageUrl } from "../../utils/getImageUrl";
import { getAllDoctors } from "../../api";

// Skeleton Loading Component
const ExpertSkeleton = () => (
  <div className="group flex-shrink-0 rounded-[10px] overflow-hidden animate-pulse bg-gray-300 h-[380px] lg:h-[420px]" />
);

const HealtCareExperts = () => {
  const [ExpertsData, setExpertsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await getAllDoctors();
        const docArr = Array.isArray(response)
          ? response
          : Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response?.doctors)
          ? response.doctors
          : [];
        setExpertsData(docArr);
      } catch (err) {
        setError("Failed to load doctors. Please try again later.");
        console.error("Error fetching doctors:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDoctors();
  }, []);

  const safeExperts = Array.isArray(ExpertsData) ? ExpertsData : [];
  //   {
  //     Image: images.ExpertOne,
  //     name: "Dr. Amit Sharma",
  //     degree: "MBBS, MD (Cardiology)",
  //     experience: "10+",
  //     desc: "Dr. Amit Sharma is a highly experienced cardiologist specializing in the diagnosis and treatment of heart-related conditions. He focuses on preventive cardiac care, lifestyle management, and advanced treatment to ensure long-term heart health...",
  //     gradient:
  //       "linear-gradient(180.09deg, rgba(102, 102, 102, 0) 44.73%, rgba(21, 21, 21, 0.159116) 70.2%, rgba(0, 0, 0, 0.2) 92.76%)",
  //     textGradient:
  //       "linear-gradient(180.22deg, rgba(98, 121, 255, 0) 5.27%, rgba(81, 105, 241, 0.430369) 25.15%, rgba(71, 95, 233, 0.679016) 47.42%, #465FEF 89.57%)",
  //   },
  //   {
  //     Image: images.ExpertTwo,
  //     name: "Dr. Rajesh Verma",
  //     degree: "MBBS, MD (Cardiology)",
  //     experience: "10+",
  //     desc: "Dr. Rajesh Verma is an expert in critical care and emergency medicine, providing life-saving treatment and continuous monitoring for critically ill patients. He ensures timely intervention and advanced ICU care...",
  //     gradient:
  //       "linear-gradient(179.92deg, rgba(102, 102, 102, 0) 38.77%, rgba(12, 12, 12, 0.26413) 55.97%, rgba(21, 21, 21, 0.238674) 57.88%, rgba(0, 0, 0, 0.3) 89.05%)",
  //     textGradient:
  //       "linear-gradient(180.22deg, rgba(60, 153, 205, 0) 2.26%, rgba(61, 155, 207, 0.5) 32.37%, rgba(46, 135, 186, 0.7) 52.24%, #2F8EC2 84.15%)",
  //   },
  //   {
  //     Image: images.ExpertThree,
  //     name: "Dr. Neha Singh",
  //     degree: "MBBS, MD (General Medicine)",
  //     experience: "8+",
  //     desc: "Dr. Neha Singh provides comprehensive healthcare services under the 24-hour health program, focusing on patient monitoring, preventive care, and overall health management...",
  //     gradient:
  //       "linear-gradient(180.09deg, rgba(102, 102, 102, 0) 44.73%, rgba(21, 21, 21, 0.238674) 61.98%, rgba(12, 12, 12, 0.26413) 72.32%, rgba(0, 0, 0, 0.3) 90.1%)",
  //     textGradient:
  //       "linear-gradient(180.22deg, rgba(221, 138, 138, 0) 2.26%, rgba(187, 100, 100, 0.5) 32.37%, rgba(204, 111, 111, 0.6) 52.24%, #C66868 84.15%)",
  //   },
  //   {
  //     Image: images.ExpertOne,
  //     name: "Dr. Priya Patel",
  //     degree: "MBBS, MS (Gynaecology)",
  //     experience: "12+",
  //     desc: "Dr. Priya Patel is a leading gynaecologist with expertise in women's health, maternal care, and minimally invasive surgical procedures, ensuring the best outcomes for her patients...",
  //     gradient:
  //       "linear-gradient(180.09deg, rgba(102, 102, 102, 0) 44.73%, rgba(21, 21, 21, 0.159116) 70.2%, rgba(0, 0, 0, 0.2) 92.76%)",
  //     textGradient:
  //       "linear-gradient(180.22deg, rgba(180, 120, 220, 0) 5.27%, rgba(155, 90, 195, 0.43) 25.15%, rgba(140, 80, 180, 0.68) 47.42%, #8C50B4 89.57%)",
  //   },
  // ];

  const itemsPerView = 3;
  const maxIndex = ExpertsData.length - itemsPerView;

  const prev = () => setCurrentIndex((p) => Math.max(0, p - 1));
  const next = () => setCurrentIndex((p) => Math.min(maxIndex, p + 1));

  if (error) {
    return (
      <div className="py-10 md:py-12">
        <h3 className="text-[22px] md:text-[28px] font-semibold text-center px-4">
          Meet Our Healthcare Experts
        </h3>
        <p className="text-[15px] md:text-[18px] text-center max-w-[750px] mx-auto my-3 px-4">
          Our team of highly qualified and experienced doctors is dedicated to
          providing the best medical care. Each specialist focuses on personalized
          treatment and patient comfort.
        </p>
        <div className="text-center py-12">
          <p className="text-red-500 font-poppins font-semibold text-[16px] mb-4">
            {error}
          </p>
          <button
            onClick={() => window.location.reload()}
            className="bg-[#1975FF] text-white px-6 py-2 rounded-[10px] hover:bg-[#1560d4] transition-all"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }
 

  return (
    <div className="py-10 md:py-12">
      <h3 className="text-[22px] md:text-[28px] font-semibold text-center px-4">
        Meet Our Healthcare Experts
      </h3>
      <p className="text-[15px] md:text-[18px] text-center max-w-[750px] mx-auto my-3 px-4">
        Our team of highly qualified and experienced doctors is dedicated to
        providing the best medical care. Each specialist focuses on personalized
        treatment and patient comfort.
      </p>

      {loading ? (
        <>
          {/* Desktop: 3-column skeleton */}
          <div className="hidden md:block w-[90%] mx-auto mt-10 overflow-hidden">
            <div className="flex gap-6 md:gap-8">
              {[...Array(3)].map((_, idx) => (
                <ExpertSkeleton key={idx} />
              ))}
            </div>
          </div>

          {/* Mobile: 1-column skeleton */}
          <div className="md:hidden w-[90%] mx-auto mt-8 overflow-hidden">
            <ExpertSkeleton />
          </div>
        </>
      ) : ExpertsData.length === 0 ? (
        <div className="text-center py-12 mt-10">
          <p className="font-poppins text-[16px] text-gray-600">
            No doctors available
          </p>
        </div>
      ) : (
        <>
          {/* Desktop: 3-column carousel */}
          <div className="hidden md:block w-[90%] mx-auto mt-10 overflow-hidden">
            <div
              className="flex gap-6 md:gap-8 transition-transform duration-400 ease-in-out"
              style={{
                transform: `translateX(calc(-${currentIndex} * (100% / 3 + 32px / 3)))`,
              }}
            >
              {ExpertsData.map((expert, idx) => (
                <Link
                 to={`/doctor-detail/${expert.slug}`}
                  key={idx}
                  className="group flex-shrink-0 rounded-[10px] overflow-hidden cursor-pointer shadow-md hover:shadow-xl transition-shadow duration-300"
                  style={{ width: "calc(33.333% - 22px)" }}
                >
                  <div
                    className="h-[380px] lg:h-[420px] w-full bg-cover bg-center flex items-end text-white transition-transform duration-500 group-hover:scale-[1.02]"
                    style={{
                      backgroundImage: `linear-gradient(180.09deg, rgba(102, 102, 102, 0) 44.73%, rgba(21, 21, 21, 0.159116) 70.2%, rgba(0, 0, 0, 0.2) 92.76%), url(${getImageUrl(expert.imagePath)})`,
                    }}
                  >
                    <div
                      className="text-white text-base p-3 px-4 w-full transition-all duration-300"
                      style={{ background: `${expert.gradientColor}` }}
                    >
                      <h3 className="text-[18px] lg:text-[20px] font-bold">
                        {expert.name}
                      </h3>
                      <p className="font-semibold text-[13px] lg:text-[14px]">
                        {expert.degree} · {expert.experience} Years Exp.
                      </p>
                      <p className="mt-2 text-[13px] lg:text-[14px] max-h-0 overflow-hidden group-hover:max-h-[100px] transition-all duration-400 ease-in-out line-clamp-4">
                        {expert.doctorDescription?.[0] || expert.descdoctorDescription?.[0]}
                      </p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {/* Arrows */}
            {ExpertsData.length > itemsPerView && (
              <div className="flex items-center justify-between mt-6">
                <button
                  onClick={prev}
                  disabled={currentIndex === 0}
                  className="p-2 border-2 border-black text-black hover:bg-black hover:text-white active:scale-95 rounded-full transition-all duration-200 disabled:opacity-30 disabled:cursor-not-allowed"
                >
                  <ChevronLeft className="w-5 h-5" />
                </button>
                <div className="flex gap-2">
                  {Array.from({ length: maxIndex + 1 }).map((_, i) => (
                    <button
                      key={i}
                      onClick={() => setCurrentIndex(i)}
                      className={`w-2 h-2 rounded-full transition-all duration-200 ${
                        i === currentIndex ? "bg-[#1975FF] w-5" : "bg-gray-300"
                      }`}
                    />
                  ))}
                </div>
                <button
                  onClick={next}
                  disabled={currentIndex >= maxIndex}
                  className="p-2 border-2 border-black text-black hover:bg-black hover:text-white active:scale-95 rounded-full transition-all duration-200 disabled:opacity-30 disabled:cursor-not-allowed"
                >
                  <ChevronRight className="w-5 h-5" />
                </button>
              </div>
            )}
          </div>

          {/* Mobile: single-card scroll */}
          <div className="md:hidden w-[90%] mx-auto mt-8 overflow-hidden">
            <div
              className="flex gap-4 transition-transform duration-400 ease-in-out"
              style={{ transform: `translateX(calc(-${currentIndex} * 100% - ${currentIndex * 16}px))` }}
            >
              {ExpertsData.map((expert, idx) => (
                <Link
                 to={`/doctor-detail/${expert.slug}`}
                  key={idx}
                  className="flex-shrink-0 w-full rounded-[10px] overflow-hidden shadow-md"
                >
                  <div
                    className="h-[360px] w-full bg-cover bg-center flex items-end text-white"
                    style={{
                      backgroundImage: `linear-gradient(180.09deg, rgba(102, 102, 102, 0) 44.73%, rgba(21, 21, 21, 0.159116) 70.2%, rgba(0, 0, 0, 0.2) 92.76%), url(${getImageUrl(expert.imagePath)})`,
                    }}
                  >
                    <div
                      className="text-white p-4 w-full"
                      style={{ background: `${expert.gradientColor}` }}
                    >
                      <h3 className="text-[18px] font-bold">{expert.name}</h3>
                      <p className="font-semibold text-[13px]">{expert.degree} · {expert.experience} Yrs</p>
                      <p className="mt-2 text-[13px] line-clamp-4">{expert.doctorDescription?.[0] || expert.descdoctorDescription?.[0]}</p>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
            <div className="flex items-center justify-between mt-5">
              <button
                onClick={prev}
                disabled={currentIndex === 0}
                className="p-2 border-2 border-black rounded-full hover:bg-black hover:text-white transition-all disabled:opacity-30 disabled:cursor-not-allowed"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <span className="text-sm text-gray-500">{currentIndex + 1} / {ExpertsData.length}</span>
              <button
                onClick={() => setCurrentIndex((p) => Math.min(ExpertsData.length - 1, p + 1))}
                disabled={currentIndex >= ExpertsData.length - 1}
                className="p-2 border-2 border-black rounded-full hover:bg-black hover:text-white transition-all disabled:opacity-30 disabled:cursor-not-allowed"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        </>
      )}

      <Link
        to="/doctors"
        className="w-fit mx-auto mt-8 bg-[#1975FF] rounded-[10px] py-1 pr-1 pl-4 flex items-center gap-2 text-[14px] font-semibold text-white hover:bg-[#1560d4] active:bg-[#1050b8] active:scale-95 transition-all duration-200 shadow-md hover:shadow-lg group"
      >
        View All Doctors{" "}
        <span className="p-2 bg-white rounded-full transition-transform duration-300 group-hover:scale-110">
          <MoveRight color="#000" className="rotate-[-38deg] w-5 h-5" />
        </span>
      </Link>
    </div>
  );
};

export default HealtCareExperts;